import React from 'react';

const ArtThumbnail = (props) => {
	const { url, name } = props.details;
	return (
		<img src={url} width="300" alt={name} onClick={() => { props.handleClick(props.details) }}/>
	);
}

export default ArtThumbnail;


// WEBPACK FOOTER //
// ./src/components/ArtThumbnail.js